import {course_getCourseClassById_Api} from 'apis'
import {getId} from 'apis/model/base'
import {FullSideModalLayout} from 'components/Modal/SideModalLayout'
import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import _ from 'lodash'
import React, {useState} from 'react'
import {BsCalendar2Week} from 'react-icons/bs'
import {FaUserGraduate, FaUserTie} from 'react-icons/fa6'
import {GoDotFill} from 'react-icons/go'
import {PiChecks, PiGraduationCap, PiMedal, PiTextSuperscriptBold} from 'react-icons/pi'
import {CourseClassStudentList} from 'views/AppLocals/Course/CourseClass/CourseClassStudentForm'
import CourseClassTeachers from 'views/AppLocals/Course/CourseClass/CourseClassTeachers'
import {CourseClassSubjectList} from 'views/AppLocals/Course/CourseClass/components/CourseClassSubjectForm'
import {useTimetableCourseClassForm} from 'views/AppLocals/Timetable/useTimetableCourseClassForm'
import {NullAsDefault, renderIf} from 'views/Shared'
import {bindingSearch} from 'views/Shared/components/PagerControls'
import LoadingBlock from 'views/Loading/LoadingBlock'
import {CourseClassTimetablePanel} from './CourseClassTimetablePanel'
import {CourseClassAttendancePanel} from './CourseClassAttendancePanel'
import {CourseClassGradingPanel} from './CourseClassGradingPanel'
import {CourseClassSummaryPanel} from './CourseClassSummaryPanel'
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../../helpers/getLinkToDetail";
import {TbTableOptions} from "react-icons/tb";

const SIDE_TABS = [
    {key: 'schedule', name: 'timetable', icon: <BsCalendar2Week size={16}/>},
    {key: 'student', name: 'student', icon: <FaUserGraduate size={14}/>},
    {key: 'teacher', name: 'teacher', icon: <FaUserTie size={14}/>},
    {key: 'subject', name: 'subject', icon: <PiTextSuperscriptBold size={16}/>},
    {key: 'attendance', name: 'attendance', icon: <PiChecks size={16}/>},
    {key: 'grading', name: 'gradebook', icon: <PiGraduationCap size={16}/>},
]

const SideTabNav = ({tabs, activeTab, onTabChange}) => {
    const t = useTranslate()
    return (
        <div className="flex gap-1 overflow-x-auto background-100 border-b border-color-300">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={classNames(
                        'px-3 py-2 flex items-center flex-shrink-0 gap-2 text-xs font-medium transition-colors border-b-2',
                        activeTab === tab.key
                            ? 'border-indigo-500 text-indigo-600'
                            : 'border-transparent text-color-200 hover:text-indigo-500 hover:border-indigo-300'
                    )}>
                    {tab.icon}
                    <span>{t(tab.name)}</span>
                </button>
            ))}
        </div>
    )
}

export const CourseClassPanelDetail = ({class_id, owner_id, owner_type, initialTab = 'schedule', onCancel = NullAsDefault, onTabChange = NullAsDefault}) => {
    const t = useTranslate()
    const [activeTab, setActiveTab] = useState(initialTab)

    const handleTabChange = (tab) => {
        setActiveTab(tab)
        onTabChange(tab)
    }
    const [item, setItem] = useState(null)
    const [showFinalAssessment, setShowFinalAssessment] = useState(false)

    const {handleAsyncAction: fetchById} = useAsyncAction({
        apiInfo: course_getCourseClassById_Api,
        onSuccess: (result, data) => {
            setItem(_.get(data, 'response.data'))
        },
    })

    React.useEffect(() => {
        if (class_id) fetchById({}, {id: class_id})
    }, [class_id])

    const {
        modal: timetableModal,
        handleAction: handleTimetableAction,
    } = useTimetableCourseClassForm({course_class: item ?? {}})

    if (!item) return <LoadingBlock/>

    const can_edit = !!item?.edit
    const course = item?.course ?? {}
    const coordinators = item?.coordinators ?? []
    const firstCoordinator = coordinators[0]

    const renderContent = () => {
        switch (activeTab) {
            case 'schedule':
                return (
                    <div className="flex flex-col gap-3">
                        <h3 className="font-bold text-sm text-gray-700 uppercase tracking-wide">
                            {t('learning schedule')}
                        </h3>
                        <CourseClassTimetablePanel item={item}/>
                    </div>
                )
            case 'student':
                return (
                    <div className="flex flex-col gap-3">
                        {can_edit && (
                            <div className="flex justify-end">
                                <button
                                    style={{ padding: '0.375rem 0.75rem', borderRadius: '0.5rem' }}
                                    className="flex items-center gap-1.5 font-medium text-xs text-gray-600 hover:text-green-500 border border-slate-300 hover:border-green-400"
                                    onClick={() => setShowFinalAssessment(true)}>
                                    <PiMedal size={13} className="text-green-500"/>
                                    {t('final assessment')}
                                </button>
                            </div>
                        )}
                        {!!item?.id && bindingSearch({
                            onCancel,
                            owner_id: item?.owner?.id,
                            owner_type: item?.owner?._type,
                            item,
                        })(CourseClassStudentList)}
                        {showFinalAssessment && (
                            <FullSideModalLayout
                                full={true}
                                title={
                                    <div className="flex items-center gap-2">
                                        <div className="p-3 flex flex-center bg-green-50 rounded-lg">
                                            <TbTableOptions size={20} className="text-green-600"/>
                                        </div>
                                        <div className="py-2 flex flex-col flex-1 gap-1">
                                            <span className="font-bold text-base text-color-000 tracking-wide">
                                                {t('final assessment')}
                                                {/*<span className="ml-2 px-2 py-0.5 bg-secondary-50 border border-secondary-400 rounded-full font-semibold text-xs text-secondary-600 tracking-wide">*/}
                                                {/*    {item?.title}*/}
                                                {/*</span>*/}
                                            </span>
                                            <span className="font-normal text-xs text-color-300 tracking-wider">
                                                {t('final assessment description')}
                                            </span>
                                        </div>
                                    </div>
                                }
                                onCancel={() => setShowFinalAssessment(false)}>
                                <CourseClassSummaryPanel course_class_id={getId(item)} titleClass={item?.title}/>
                            </FullSideModalLayout>
                        )}
                    </div>
                )
            case 'teacher':
                return (
                    <div className="flex flex-col">
                        {!!item?.id && bindingSearch({
                            onCancel,
                            owner_id: item?.owner?.id,
                            owner_type: item?.owner?._type,
                            item,
                        })(CourseClassTeachers)}
                    </div>
                )
            case 'subject':
                return (
                    <div className="flex flex-col gap-3">
                        <h3 className="font-bold text-sm text-gray-700 uppercase tracking-wide">
                            {t('subjects')} ({(item?.class_subjects ?? []).length})
                        </h3>
                        {!!item?.id && bindingSearch({
                            onCancel,
                            item,
                        })(CourseClassSubjectList)}
                    </div>
                )
            case 'attendance':
                return (
                    <div className="flex flex-col gap-3">
                        <h3 className="font-bold text-sm text-gray-700 uppercase tracking-wide o-day">
                            {t('attendance')}
                        </h3>
                        <CourseClassAttendancePanel item={item}/>
                    </div>
                )
            case 'grading':
                return (
                    <div className="flex flex-col gap-3">
                        <h3 className="font-bold text-sm text-gray-700 uppercase tracking-wide">
                            {t('gradebook')}
                        </h3>
                        <CourseClassGradingPanel item={item}/>
                    </div>
                )
            default:
                return null
        }
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="px-3 pt-3 pb-2 flex flex-col gap-1 background-50 rounded-lg 222-222">
                <Link to={getLinkToDetail(item)} className="font-bold text-base text-color-000 tracking-wide no-underline">
                    {item?.title}
                </Link>
                <div className="flex flex-wrap gap-x-4 gap-y-1">
                    {renderIf(
                        item?.course_class_idcode,
                        <span className="text-xs text-color-400 italic">
                            {`#${item?.course_class_idcode}`}
                        </span>
                    )}
                    {renderIf(
                        getTitle(course),
                        <span className="text-xs text-color-400 italic">
                            <GoDotFill size={8} className="inline mr-1 text-color-400"/>
                            {getTitle(course)}
                        </span>
                    )}
                    {renderIf(
                        firstCoordinator,
                        <span className="text-xs text-color-400 italic">
                            <GoDotFill size={8} className="inline mr-1 text-color-400"/>
                            {firstCoordinator?.teacher_name}
                        </span>
                    )}
                    <span className="text-xs text-color-400 italic">
                        <GoDotFill size={8} className="inline mr-1 text-color-400"/>
                        {`${item?.number_of_students ?? 0} ${t('students').toLowerCase()}`}
                    </span>
                </div>
            </div>
            <SideTabNav tabs={SIDE_TABS} activeTab={activeTab} onTabChange={handleTabChange}/>
            <div className="mt-1">
                {renderContent()}
            </div>
        </div>
    )
}
